<a
  href="https://wa.me/966535354922?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%D8%8C%20%D9%83%D9%8A%D9%81%20%D8%A3%D9%82%D8%AF%D8%B1%20%D8%A3%D8%B3%D8%A7%D8%B9%D8%AF%D9%83%3F"
  target="_blank"
  rel="noopener noreferrer"
  class="whatsapp-float"
>
  <i class="fa-brands fa-whatsapp"></i>
</a>
